import {
    LOAN_TYPE_ID, LOAN_TYPE_NAME,
} from '../../types';

const getProductID = (loanType:string) => {
    switch (loanType) {
    case LOAN_TYPE_NAME.SECURED:
        return LOAN_TYPE_ID.SECURED;
    case LOAN_TYPE_NAME.UNSECURED_FIXED:
        return LOAN_TYPE_ID.UNSECURED_FIXED;
    case LOAN_TYPE_NAME.UNSECURED_VARIABLE:
        return LOAN_TYPE_ID.UNSECURED_VARIABLE;
    default:
        return LOAN_TYPE_ID.UNSECURED_VARIABLE;
    }
};

export default getProductID;
